import React, { useEffect, useRef, useState } from "react";
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";

type Props = {
    page : number;
    totalPage : number;
    onPageChange : (page : number) => Promise<void>;
};

export default function PaginationSet({ page, totalPage, onPageChange }: Props) {

  const [length, setLength] = useState<number>(0);
  const index = useRef<number>(0);
  let last5PagesStart = totalPage - 4;

  useEffect(() => {
    if(page + 4 >= totalPage) {
      setLength(5);
    }
    index.current = page;
  },[page, totalPage]);

  return (
    <Pagination>
        <PaginationItem>
          <PaginationLink onClick={()=> onPageChange(1)}>
            {"<<"}
          </PaginationLink>
        </PaginationItem>
        {
          page !== 1 &&
          <PaginationItem>
            <PaginationLink onClick={()=> onPageChange(page - 1)}>
              {"<"}
            </PaginationLink>
          </PaginationItem>
        }
        {
          page >= last5PagesStart && page <= totalPage ?
          Array.from({ length: 5 }, (_, i) => {
            let currentPage = last5PagesStart + i;
            if(currentPage <= 0) {
              return <React.Fragment key={i}></React.Fragment>;
            }
            return (
              <PaginationItem key={i} active={currentPage === page}>
                <PaginationLink onClick={()=> onPageChange(currentPage)}>
                  {currentPage}
                </PaginationLink>
              </PaginationItem>
            )
          })
          :
          Array.from({ length: length }, (_, i) => {
            let currentPage = page + i;
            return (
              <PaginationItem key={i} active={currentPage === page}>
                <PaginationLink onClick={()=> onPageChange(currentPage)}>
                  {currentPage}
                </PaginationLink>
              </PaginationItem>
            )
          })
        }
        {
          page !==totalPage &&
          <PaginationItem>
            <PaginationLink onClick={()=> onPageChange(page + 1)}>
              {">"}
            </PaginationLink>
          </PaginationItem>
        }
        <PaginationItem >
          <PaginationLink onClick={()=> onPageChange(totalPage)}>
            {">>"}
          </PaginationLink>
        </PaginationItem>
    </Pagination>
  );
}
